<template>
  <main-input-dialog
    :is-visible.sync="computedIsVisible"
    :title-translation="$i18n.t('dialog.attributeSettings')"
    dialog-width="40%"
    min-body-height="350px"
    agree-text="dialog.agreeSave"
    :inputs="inputs"
    @agree="agree"
    :has-agree="hasAgree"
    :loading="loading"
  >
    <template #virtual.input>
      <v-col cols="12" class="pb-4">
        <v-row no-gutters>
          <v-checkbox
            v-model="computedAttribute.isVirtual"
            :disabled="(disabledVirtual && !isNew) || loading"
            hide-details
          >
            <template #label>
              <span class="text-body-2 text-left" :class="{ 'font--text': isNew || !disabledVirtual }">
                {{ $i18n.t('dialog.attributeVirtual') }}
              </span>
            </template>
          </v-checkbox>
        </v-row>
        <v-row no-gutters v-if="computedAttribute.isVirtual" class="pt-3">
          <v-col cols="12">
            <data-input
              v-model="computedAttribute.data_type.expression"
              :disabled="(disabledVirtual && !isNew) || loading"
              :dataType="{ name: 'textarea' }"
              clearable
            />
          </v-col>
        </v-row>
      </v-col>
    </template>
    <template #alert.input="{ text }">
      <v-col cols="12">
        <v-alert type="warning" icon="mdi-alert-outline" dense text class="text-left text-caption">
          {{ text }}
        </v-alert>
      </v-col>
    </template>
    <template v-for="(key, idx) of descriptorsKeys" #[`${key}.input`]="data">
      <v-col :cols="data.rightCol || 'auto'" :key="idx">
        <data-input v-model="computedAttribute.data_type[key]" v-bind="data" />
      </v-col>
    </template>
  </main-input-dialog>
</template>
<script>
import { get } from 'vuex-pathify';

import DataInput from '@/components/DataInput';
import MainInputDialog from '@/components/MainInputDialog';

import descriptors from '@/mixins/descriptors';

export default {
  name: 'DataSourceAttributeSettingsDialog',
  components: { DataInput, MainInputDialog },
  mixins: [descriptors],
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    attribute: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabledVirtual: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataTypes: get('layers/dataTypes'),
    isNew() {
      return Boolean(this.computedAttribute.new);
    },
    dataType() {
      return this.attribute.data_type;
    },
    dataTypeMetadata() {
      return this.dataTypes.find(dt => dt.name === this.dataType.name);
    },
    dataTypeMetadataDescriptors() {
      return this.dataTypeMetadata?.descriptors || [];
    },
    dataTypeDescriptorsAD() {
      return this.descriptorsAdditionalData[this.dataType.name]?.descriptors || {};
    },
    descriptors() {
      return Object.entries(this.dataTypeDescriptorsAD).reduce((total, [key, value]) => {
        this.dataTypeMetadataDescriptors;
        const descriptor = {
          name: key,
          straightTitle: this.$_capitalize(this.dataTypeMetadataDescriptors[key] || ''),
          leftCol: 5,
          rightCol: 4,
          disabled: this.loading,
          ...value,
        };
        total.push(descriptor);
        return total;
      }, []);
    },
    descriptorsKeys() {
      return this.descriptors.map(d => d.name);
    },

    alert() {
      return this.descriptorsAdditionalData[this.dataType.name]?.alert || '';
    },

    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.$emit('update:isVisible', value);
      },
    },
    computedAttribute: {
      get() {
        return this.attribute;
      },
      set(value) {
        this.$emit('update:attribute', value);
      },
    },
    inputs() {
      return [
        ...(!this.computedAttribute.isVirtual && this.disabledVirtual && !this.isNew
          ? []
          : [
              {
                name: 'virtual',
                leftCol: 0,
              },
            ]),
        ...(this.alert ? [{ name: 'alert', text: this.alert, leftCol: 0 }] : []),
        ...this.descriptors,
      ];
    },
    hasAgree() {
      return Boolean(
        this.isNew ||
          !this.disabledVirtual ||
          this.descriptors.find(descriptor => !descriptor.disabled) ||
          (this.loading && this.descriptors?.length)
      );
    },
  },
  methods: {
    agree(attribute = JSON.parse(JSON.stringify(this.computedAttribute))) {
      if (!attribute.isVirtual) delete attribute.data_type.expression;
      delete attribute.new;
      delete attribute.isVirtual;
      delete attribute.index;
      this.descriptorsKeys.forEach(key => {
        const descriptorValue = attribute.data_type[key];
        if (!descriptorValue && descriptorValue !== 0 && descriptorValue !== false) delete attribute.data_type[key];
      });
      this.$emit('input', attribute);
    },
  },
};
</script>
